'use client';

import { ChevronLeftIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { Button } from '@/components/ui/button';
import { useRouter } from '@/i18n/routing';

export const BackButton = () => {
    const router = useRouter();

    const handleBack = () => {
        router.back();
    };

    const t = useTranslations();

    return (
        <Button variant='ghost' onClick={handleBack} className='-m-2 flex items-center gap-2 pl-2 pr-3 [&_svg]:size-5'>
            <ChevronLeftIcon />
            <span>{t('back')}</span>
        </Button>
    );
};
